import styled from 'styled-components';

import { StyledFilterDrawer } from '@components/views/components/listing/drawer/ResponsiveListingFilterAndSortStyle';

export const TourMobileHeaderWrapper = styled.div`
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.palette.grey1100};
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const NavigationButton = styled.button`
  all: unset;
  cursor: pointer;
`;

export const MobileHeaderBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const HotelLocationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  span {
    color: ${({ theme }) => theme.palette.white};
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
  }
`;

export const HotelDateAndGuestWrapper = styled.div`
  color: ${({ theme }) => theme.palette.grey600};
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
`;

export const Drawer = styled(StyledFilterDrawer)`
  .setur-drawer-content-wrapper {
    height: 100% !important;
  }

  .setur-drawer-header {
    height: 60px;
    padding: 18px 16px;
    background: ${({ theme }) => theme.palette.grey1100};

    .setur-drawer-header-title {
      flex-direction: row-reverse;

      .setur-drawer-title {
        color: ${({ theme }) => theme.palette.white};
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        margin: 0px;
        text-align: left;
      }
    }
  }

  .setur-drawer-body {
    margin-bottom: 0px;
    overflow: auto;
    padding: 24px 12px 50px 12px !important;
  }

  .setur-drawer-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-top: 1px solid ${({ theme }) => theme.palette.grey300};
    background: ${({ theme }) => theme.palette.white};
    padding: 12px;
  }
`;
